import React from 'react';
import UserSocialNetwork from '../domain/UserSocialNetwork';

export type ValidatorFunction<T> = (value: T) => boolean;

export type Validator<T> = {
    fieldName: string;
    fieldValue: T;
    isValid: ValidatorFunction<T>;
};

export type ErrorsState = {
    [key: string]: boolean;
};


const validate = (
    validators: Validator<string | boolean | object | UserSocialNetwork[]>[],
    setErrors: React.Dispatch<React.SetStateAction<ErrorsState>>
): boolean => {
    const e2: Record<string, boolean> = {};

    validators.forEach((v) => {
        e2[v.fieldName] = !v.isValid(v.fieldValue);
    });
    const isInvalid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);
    setErrors((errors) => ({ ...errors, ...e2 }));
    return !isInvalid;
};

const isSelected: ValidatorFunction<boolean> = (item) => {
    return item !== null && typeof item !== 'undefined';
};

const isNotFalsy: ValidatorFunction<object> = (item) => {
    return !!item;
};

const isTrue: ValidatorFunction<boolean> = (item) => {
    return item !== null && typeof item !== 'undefined' && !!item;
};

const isCompleted: ValidatorFunction<string> = (val) => val && val.length >= 2;
const isValidPassword: ValidatorFunction<string> = (val) => val && val.length >= 8;

const isValidEmail: ValidatorFunction<string> = (email) => {
    /* eslint-disable no-useless-escape */
    const re =
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return !(email === null || !re.test(String(email).toLowerCase()));
};

const isValidYouTubeOrEmpty: ValidatorFunction<string> = (link) => {
    const re = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
    return typeof link === 'undefined' || link === null || link === '' || re.test(String(link).toLowerCase());
};

export {
    isSelected,
    isTrue,
    isCompleted,
    isValidPassword,
    isValidEmail,
    isValidYouTubeOrEmpty,
    validate,
    isNotFalsy
};
